/**
 * AI Module Configuration
 *
 * Centralized configuration for the AI module, including backend API URLs.
 */

const config = {
  backendUrl: import.meta.env.VITE_AI_BACKEND_URL || "http://localhost:8000",
};

export default config;
